import noUiSlider from 'nouislider';
import { ajaxPriceSliderListing } from './filter';

const uxProductFilters = {};
let needToUpdate = true;

export const init = () => {
  uxProductFiltersRangeRender();
};

export const uxProductFiltersRangeRender = () => {
  uxProductFilters.range = document.getElementById('range_filter');

  if (uxProductFilters.range) {
    uxProductFilters.range.sliderContainer = document.getElementById('noUiSliderContainer');
    uxProductFilters.range.slider = uxProductFilters.range.querySelector('input.range');
    uxProductFilters.range.minValue = Math.floor(parseFloat(uxProductFilters.range.slider.min));
    uxProductFilters.range.maxValue = Math.ceil(parseFloat(uxProductFilters.range.slider.max));
    uxProductFilters.range.fromValue = Math.floor(parseFloat(uxProductFilters.range.slider.dataset.from));
    uxProductFilters.range.toValue = Math.ceil(parseFloat(uxProductFilters.range.slider.dataset.to));
    uxProductFilters.range.minInput = uxProductFilters.range.querySelector('.min-value');
    uxProductFilters.range.maxInput = uxProductFilters.range.querySelector('.max-value');



    uxProductFilters.range.sliderPrefix = () => {
      if (typeof uxProductFilters.range.slider.dataset.currencyPrefix !== 'undefined') {
        uxProductFilters.prefix = `${uxProductFilters.range.slider.dataset.currencyPrefix}\xa0`;
      } else {
        uxProductFilters.prefix = '';
      }
      return uxProductFilters.prefix;
    };

    uxProductFilters.range.sliderPostfix = () => {
      if (typeof uxProductFilters.range.slider.dataset.currencyPostfix !== 'undefined') {
        uxProductFilters.postfix = `\xa0${uxProductFilters.range.slider.dataset.currencyPostfix}`;
      } else {
        uxProductFilters.postfix = '';
      }
      return uxProductFilters.postfix;
    };

    if (!uxProductFilters.range.sliderContainer.noUiSlider) {
      noUiSlider.create(uxProductFilters.range.sliderContainer, {
        connect: true,
        range: {
          min: Math.round(parseFloat(uxProductFilters.range.minValue)),
          max: Math.round(parseFloat(uxProductFilters.range.maxValue))
        },
        start: [parseFloat(uxProductFilters.range.fromValue), parseFloat(uxProductFilters.range.toValue)],
        format: {
          to: value => uxProductFilters.range.sliderPrefix() + Math.round(parseFloat(value)) + uxProductFilters.range.sliderPostfix(),
          from: value => value
        }
      });
    }

    uxProductFilters.range.minInput.value = uxProductFilters.range.sliderPrefix() + uxProductFilters.range.sliderContainer.noUiSlider.options.start[0] + uxProductFilters.range.sliderPostfix();
    uxProductFilters.range.maxInput.value = uxProductFilters.range.sliderPrefix() + uxProductFilters.range.sliderContainer.noUiSlider.options.start[1] + uxProductFilters.range.sliderPostfix();

    // Value of the max input before change
    uxProductFilters.range.currentMaxInputValue = parseInt(uxProductFilters.range.maxInput.value, 10);
    // Value of the min input before change
    uxProductFilters.range.currentMinInputValue = parseInt(uxProductFilters.range.minInput.value, 10);

    uxProductFilters.range.querySelector('.max-value').addEventListener('change', e => {
      needToUpdate = true;
      let value = parseInt(e.target.value, 10);
      if (Number.isNaN(value) || !Number.isFinite(value) || !value || value < uxProductFilters.range.minValue || value > uxProductFilters.range.maxValue || value === uxProductFilters.range.currentMaxInputValue) {
        value = uxProductFilters.range.currentMaxInputValue;
        needToUpdate = false;
      }
      uxProductFilters.to = value;
      uxProductFilters.range.currentMaxInputValue = value;
      uxProductFilters.range.sliderContainer.noUiSlider.set([null, value]);
      if (needToUpdate) {
        ajaxUpdateFilters([
          parseInt(uxProductFilters.range.sliderContainer.noUiSlider.options.start[0], 10),
          value
        ]);
      }
    });

    uxProductFilters.range.querySelector('.min-value').addEventListener('change', e => {
      needToUpdate = true;
      let value = parseInt(e.target.value, 10);
      if (Number.isNaN(value) || !Number.isFinite(value) || !value || value > uxProductFilters.range.maxValue || value < uxProductFilters.range.minValue || value === uxProductFilters.range.currentMinInputValue) {
        value = uxProductFilters.range.currentMinInputValue;
        needToUpdate = false;
      }
      uxProductFilters.from = value;
      uxProductFilters.range.currentMinInputValue = value;
      uxProductFilters.range.sliderContainer.noUiSlider.set([value, null]);
      if (needToUpdate) {
        ajaxUpdateFilters([
          value,
          parseInt(uxProductFilters.range.sliderContainer.noUiSlider.options.start[1], 10)]
        );
      }
    });

    uxProductFilters.range.querySelector('.min-value').addEventListener('click', e => {
      e.target.value = null;
    });

    uxProductFilters.range.querySelector('.max-value').addEventListener('click', e => {
      e.target.value = null;
    });

    uxProductFilters.range.querySelector('.max-value').addEventListener('blur', e => {
      if (e.target.value.length < 1) {
        e.target.value = uxProductFilters.to;
      }
    });

    uxProductFilters.range.querySelector('.min-value').addEventListener('blur', e => {
      if (e.target.value.length < 1) {
        e.target.value = uxProductFilters.from;
      }
    });

    uxProductFilters.range.sliderContainer.noUiSlider.on('update', (values, handle) => {
      if (handle === 0) {
        uxProductFilters.from = values[0];
        uxProductFilters.range.minInput.value = values[handle];
      } else if (handle === 1) {
        uxProductFilters.to = values[1];
        uxProductFilters.range.maxInput.value = values[handle];
      }
    });

    uxProductFilters.range.sliderContainer.noUiSlider.on('change', values => {
      if (needToUpdate) {
        ajaxUpdateFilters(values);
      }
    });
  }
};

const ajaxUpdateFilters = values => {
  window.decathlon.tools.showHideLoadingGif('show');
  ajaxPriceSliderListing({ from: parseInt(values[0], 10), to: parseInt(values[1], 10) });
};



// WEBPACK FOOTER //
// ./src/catalog/product-list/product-filters.js